// extracted by mini-css-extract-plugin
module.exports = {"meter":"styles_meter__G1Xyx","bar":"styles_bar__5fQEY"};